module.exports = __webpack_public_path__ + "static/media/cup_copper.fe108213.png";